const appUrl =
    process.env.REACT_APP_URL || 'https://uatmaster.bintix.com/api/v1/admin/';

const newAppUrl =
    process.env.REACT_APP_NEW_URL || 'https://uatmaster.bintix.com/node/new/api';

export const isUatEnvironment =
    appUrl.includes('uat') || newAppUrl.includes('uat');
